module.exports = __webpack_public_path__ + "static/media/emirates-card.989210d5.gif";